import { render } from "./MiniApp.vue?vue&type=template&id=8876f714&scoped=true"
import script from "./MiniApp.vue?vue&type=script&lang=js"
export * from "./MiniApp.vue?vue&type=script&lang=js"

import "./MiniApp.vue?vue&type=style&index=0&id=8876f714&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8876f714"]])

export default __exports__